import { useAuth } from "@hooks/useAuth";
import PortalPopout from "../common/Popout/PortalPopout";
import { useRef, useState } from "react";
import Icon from "../common/Icon";

const Profile = () => {
	const { user, logout } = useAuth();
	const triggerRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);
	return (
		<>
			<button
				type="button"
				className="appearance-none flex gap-2 items-center cursor-pointer"
				data-testid="user-profile-popover"
				ref={triggerRef}
				aria-label="Open user profile menu"
				onClick={() => setIsOpen((prev) => !prev)}
			>
				<img
					src={user.auth0.picture}
					alt=""
					className="rounded-full w-8 h-8 min-w-8 md:w-12 md:h-12 md:min-w-12"
				/>
				<span className="hidden md:inline">{user.name}</span>
			</button>
			<PortalPopout
				triggerRef={triggerRef}
				isOpen={isOpen}
				onClose={close}
				zIndex={152}
			>
				<div className="flex flex-col items-center text-center gap-2 p-8 text-sm">
					<button
						type="button"
						className="appearance-none absolute text-primary-blue top-2 right-2"
						onClick={close}
						aria-label="Close"
					>
						<Icon name="cyber-close" size="lg" />
					</button>
					<h3>{user.email}</h3>
					<hr className="my-2" />
					{user.uwr && (
						<>
							<p className="lead font-bold">{"Underwriter"}</p>
							<hr className="my-2" />
						</>
					)}
					<button
						type="button"
						className="btn bg-primary-blue text-white w-full"
						onClick={logout}
					>
						Logout
					</button>
				</div>
			</PortalPopout>
		</>
	);
};

export default Profile;
